export function getInstance () {
  let VcoAdapter
  if (!window.opener) {
    VcoAdapter = window.vAdapters.VisaSRCI
  } else {
    VcoAdapter = window.opener.vAdapters.VisaSRCI
  }
  return new VcoAdapter()
}
